import { LOAD_CONSUMER_API_DATA } from '../constants'

const consumerApi = (state={}, action) => {
  switch(action.type) {
    case LOAD_CONSUMER_API_DATA:
      return {...action.data}
    default:
      return state;
  }
}

export default consumerApi


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/reducers/consumerApiReducer.js